import httpClient from "../httpClient";
import { API_COMPLICATION_DELETE } from "../config";

const deleteComplication = {
    delete: (id) => httpClient.delete(API_COMPLICATION_DELETE + '/' + id),
};

export default deleteComplication;